import Ajv from 'ajv'

export const VALIDATION_MODES = {
  JSON_SCHEMA: 'JSON_SCHEMA',
  MANDATORY_CHECKED: 'MANDATORY_CHECKED',
  ONE_OF_LIST: 'ONE_OF_LIST',
  REQUIRED: 'REQUIRED',
  SUBSET_OF_LIST: 'SUBSET_OF_LIST',
  ONLY_QUOTATION: 'ONLY_QUOTATION',
}

const ajv = new Ajv()

function isJsonSchemaValid(data, schema) {
  if (Array.isArray(data)) {
    data = data[0]
  }

  let validate = ajv.getSchema(schema.$id)
  if (!validate) {
    ajv.addSchema(schema, schema.$id)
    validate = ajv.getSchema(schema.$id)
  }

  return validate(data)
}

function isOneOfListValid(data, list) {
  if (!Array.isArray(data)) {
    data = [data]
  }

  let match = false
  for (const item of data) {
    for (const schema of list) {
      switch (schema.mode) {
        case VALIDATION_MODES.ONE_OF_LIST:
          match = isOneOfListValid(item, schema.list)
          break

        case VALIDATION_MODES.SUBSET_OF_LIST:
          match = isSubsetOfListValid(item, schema.list, schema.min)
          break

        case VALIDATION_MODES.JSON_SCHEMA:
          match = isJsonSchemaValid(item, schema.schema)
          break

        default:
          break
      }

      if (match) {
        return true
      }
    }
  }

  return false
}

function isRequiredValid(data, schema) {
  switch (schema.mode) {
    case VALIDATION_MODES.ONE_OF_LIST:
      return isOneOfListValid(data, schema.list)

    case VALIDATION_MODES.SUBSET_OF_LIST:
      return isSubsetOfListValid(data, schema.list, schema.min)

    case VALIDATION_MODES.JSON_SCHEMA:
      return isJsonSchemaValid(data, schema.schema)

    default:
      return false
  }
}

function isSubsetOfListValid(data, list, min) {
  if (!Array.isArray(data)) {
    data = [data]
  }

  let matches = 0
  for (const item of data) {
    for (const schema of list) {
      switch (schema.mode) {
        case VALIDATION_MODES.ONE_OF_LIST:
          if (isOneOfListValid(item, schema.list)) {
            matches++
          }
          break

        case VALIDATION_MODES.SUBSET_OF_LIST:
          if (isOneOfListValid(item, schema.list, schema.min)) {
            matches++
          }
          break

        case VALIDATION_MODES.JSON_SCHEMA:
          if (isJsonSchemaValid(item, schema.schema)) {
            matches++
          }
          break

        default:
          break
      }

      if (matches >= min) {
        return true
      }
    }
  }

  return false
}

export function isValidMode(data, schema) {
  switch (schema.mode) {
    case VALIDATION_MODES.MANDATORY_CHECKED:
    case VALIDATION_MODES.REQUIRED:
      return isRequiredValid(data, schema.required)

    case VALIDATION_MODES.ONE_OF_LIST:
      return isOneOfListValid(data, schema.list)

    case VALIDATION_MODES.SUBSET_OF_LIST:
      return isSubsetOfListValid(data, schema.list, schema.min)

    case VALIDATION_MODES.JSON_SCHEMA:
      return isJsonSchemaValid(data, schema.schema)

    default:
      return false
  }
}
